/*
*  Site content. Copy is word-for-word from the original Wix site (www.dikalohighston.co.za) - check with the client before rewording
*/

export const SITE_NAME = "Dikalo Highston | Bryanston";
export const SITE_URL = "https://www.dikalohighston.co.za";
export const DEFAULT_DESCRIPTION = "Dikalo Highston is a professionally run four-star guesthouse, experience tranquil, private and peaceful accommodation at its best.";

export const ROUTES = {
  HOME: "/",
  ABOUT: "/about-us",
  SERVICES: "/services",
  ROOMS: "/rooms-suites",
  EVENTS: "/private-events",
  GALLERY: "/gallery",
  CONTACT: "/contact",
  //Not in the menu - a stand-alone page linking to the two menus
  MENUS: "/menus",
};

//Section ids that other pages link to
export const ANCHORS = {
  EVENT_FORM: "contactform", //Same id as on Wix (/private-events#contactform)
  GROUP_BOOKING: "group-booking",
  FAQ: "faq",
};

export const BOOKING_LINK = "https://book.nightsbridge.com/24434";

export const NAV_LINKS = [
  { label: "Home", path: ROUTES.HOME },
  { label: "About Us", path: ROUTES.ABOUT },
  { label: "Services", path: ROUTES.SERVICES },
  { label: "Rooms & Suites", path: ROUTES.ROOMS },
  { label: "Private Events", path: ROUTES.EVENTS },
  { label: "Gallery", path: ROUTES.GALLERY },
  { label: "Contact", path: ROUTES.CONTACT },
];

//Two columns of links in the footer, in the Wix order
export const FOOTER_LINKS = [
  [
    { label: "Home", path: ROUTES.HOME },
    { label: "About Us", path: ROUTES.ABOUT },
    { label: "Rooms & Suites", path: ROUTES.ROOMS },
    { label: "Private Functions", path: ROUTES.EVENTS },
  ],
  [
    { label: "Contact Us", path: ROUTES.CONTACT },
    //Went to the top of the Contact page on Wix - now straight to the FAQ
    { label: "FAQ", path: `${ROUTES.CONTACT}#${ANCHORS.FAQ}` },
    { label: "Bookings", href: BOOKING_LINK },
  ],
];

export const CONTACT_DETAILS = {
  //Wix had "Johannesburg ,Gauteng" - the stray space made the comma wrap onto its own line on phones
  ADDRESS: "9 Highland Avenue Bryanston, Johannesburg, Gauteng",
  MAP_LINK: "https://www.google.com/maps/search/?api=1&query=9+Highland+Avenue,+Bryanston,+Johannesburg",
  MAP_EMBED: "https://maps.google.com/maps?q=9%20Highland%20Avenue%2C%20Bryanston%2C%20Johannesburg&z=15&output=embed",
  WHATSAPP: { label: "Whatsapp: +27 83 656 1137", link: "https://wa.me/27836561137" },
  //Shown as "T. +27 71 869 2674" on Wix, but linked to info@dikalohighston.co.za - now dials the number
  EVENTS_PHONE: { label: "T. +27 71 869 2674", link: "tel:+27718692674" },
  //Wix showed these two addresses but linked both to info@dikalohighston.co.za - they now go to the address shown. Confirm with the client
  ACCOMMODATION_EMAIL: "dikalohs@gmail.com",
  EVENTS_EMAIL: "dikaloevents@gmail.com",
  FACEBOOK_LINK: "https://www.facebook.com/Dikalohs/",
  INSTAGRAM_LINK: "https://www.instagram.com/dikalohighston/",
  LINKEDIN_LINK: "https://www.linkedin.com/company/dikalo-highston/",
  TOP_REVIEWS_LINK: "https://www.topreviews.co.za/best-wedding-venues-johannesburg/",
  AFRISTAY_LINK: "https://www.afristay.com/p/30112",
  TRIPADVISOR_LINK: "https://www.tripadvisor.com/Hotel_Review-g2076941-d13809322-Reviews-Dikalo_Highston-Bryanston_Sandton_Greater_Johannesburg_Gauteng.html",
  TRIPADVISOR_LOCATION_ID: "13809322",
};

export const CREDIT = { label: "TapX", link: "https://www.tap-x.com/" };

/* ------------------------------ HOME ------------------------------ */

export const HOME = {
  TITLE: "Guesthouse | Dikalo Highston | Bryanston",
  HERO: "Welcome to a world where elegance meets excellence, and every experience is a testament to the art of living well. Welcome to Dikalo",
  INTRO: "In the heart of Bryanston, Sandton, Dikalo Highston offers a distinctive blend of boutique corporate accommodation, executive hospitality, and sophisticated event spaces. Whether hosting business travellers, executive meetings, conferences, or private celebrations, our thoughtfully designed spaces and personalised service create an experience defined by comfort, discretion, and effortless professionalism.",
  CARDS: [
    {
      title: ["Accommodation", "stylish comfort"],
      text: "More than a place to stay, Dikalo Highston is where business travellers, families, medical visitors, sports teams and school communities find comfort, rest and warm hospitality in Bryanston, just minutes from Sandton.",
      link: { label: "Book your Room", href: BOOKING_LINK },
    },
    {
      title: ["Local excellence"],
      text: "At Dikalo Highston, we believe every gathering should inspire progress. We are a  MICE venue in Bryanston,we partner with you to create executive meetings, conferences, educational workshops and team building sessions that are thoughtfully planned, professionally delivered and remembered for all the right reasons.Our team works closely with you to design and execute meetings that are tailored to meeting these specific goals.",
      link: { label: "Business meeting Enquiries", path: ROUTES.CONTACT },
    },
    {
      title: ["Personal convenience"],
      text: "Beyond our gate lies a sanctuary of manicured gardens, poolside elegance, and thoughtfully curated spaces designed for those who value privacy, beauty, and impeccable professionalism. For your personal convenience in Bryanston we accommodate up to 100 people.",
      link: { label: "Plan your Event", path: ROUTES.EVENTS },
    },
  ],
  TESTIMONIALS_TITLE: "What our clients say about us",
  TESTIMONIALS: [
    {
      quote: "Moving is stressful, and when you move between countries the stress is so much more. Landing in South Africa and needing a home between homes, we arrived at the Dikalo Highston exhausted and stressed out. Immediately we were reminded of what it is to be hosted by South Africans'. The staff made us feel at home and catered to our unique needs without being asked. It was a pleasure and pure joy to have a sanctuary from the chaos we found ourselves in. Thank you to the staff of Dikalo Highston for your grace and excellent service. You are an example for all in the hospitality business to strive to.",
      author: "Conner",
    },
    {
      quote: "What a gem. It is located in a quiet area. The Staff is friendly, helpful and ready to assist. The breakfast is sumptuous, and I was prepared a gluten-free meal upon request on booking. The rooms are neat and solar powered during loadshedding. They also do private events. Most definitely a contender for my daughter's graduation party.",
      author: "Progress Ditsele",
    },
    {
      quote: "My friend I enjoyed the stay. It was a good place for us to rest in a quiet place because that's what we were looking for. The staff and owner were very friendly and helpful not forgetting to mention the security guards. Loved the place overall and will definitely go back for my rest retreat. Thank you",
      author: "Phumziletiya",
    },
    {
      quote: "It was our second visit at Dikalo, our stay was exceptional! The management and the staff were incredibly welcoming and helpful throughout our stay. The apartment was spotless, spacious, and very comfortable, we really were like as Home. Our little one also enjoyed ! We also enjoyed the delicious food, especially the fish and chips, and also the buffet, which offered a wide variety of options. The location is perfect, within walking distance of all major attractions very secure. Can't wait to return again !",
      author: "Arnaud Ngongang",
    },
    {
      quote: "What an amazing home away from home. Such professional and friendly staff, great view, the garden and pool side is stunning. There's peace of mind and the rooms are clean and comfortable. The breakfast was so tasty and well served. The whole staff is friendly and helpful. I'm definitely coming back soon.",
      author: "Vincent Nkalanga",
    },
    {
      quote: "I hosted a 40th birthday for my husband this past Sunday. And to say it was amazing is an understatement!!! The staff at Dikalo Highston truly know what it means to create an experience. Everything Jessica and I spoke about was there. The spit braai was amazing! The men and women who helped were also on the ball. It felt magical. And honestly a group of people who were there to please. I can't recommend this place enough, it was special to host a private event here and we are still receiving rave reviews from our guests. Thank you",
      author: "Mandisa Avutia",
    },
    {
      quote: "Friendly staff, clean rooms and location close to most shops and businesses",
      author: "Elmar Keyser",
    },
    {
      quote: "A very nice place to stay. I did enjoy my stay and really appreciate how they handle visitors. I would love to stay again with my whole family. Peaceful place indeed. It was a walking distance to where my church conference was",
      author: "Mrs D Motshoane",
    },
  ],
  CARDS_2: [
    {
      title: ["Embrace elegance and authenticity"],
      text: "From the moment you arrive, immerse yourself in a tapestry of elegance and authenticity. Every detail is meticulously crafted to celebrate life's simplest joys.",
      link: { label: "Read More", path: ROUTES.EVENTS },
    },
    {
      title: ["A celebration of life"],
      text: "Dikalo is more than a destination; it's a celebration of life itself.  We honor the art of culinary excellence, and offer unparalleled seclusion for those seeking respite.",
      link: { label: "Read More", path: ROUTES.ROOMS },
    },
    {
      title: ["Discover vibrant connections"],
      text: "Experience the vibrant pulse of our multicultural community, where connections flourish, experiences intertwine, and memories are woven into the fabric of time.",
      link: { label: "Read More", path: ROUTES.SERVICES },
    },
  ],
  OUTRO: "Whether you're indulging in a culinary adventure, immersing yourself in local culture, or simply relaxing in our elegant accommodation, Dikalo is more than a boutique hotel—it's a celebration of life's simple pleasures, reimagined for the modern traveler.",
  QUOTE: "“At Dikalo, we believe in creating meaningful experiences that stay with you long after the celebration ends. Our goal is simple: to make every gathering a joyful and elegant affair.”",
  QUOTE_BY: "Dikalo Team",
};

/* ------------------------------ ABOUT ------------------------------ */

export const ABOUT = {
  DESCRIPTION: DEFAULT_DESCRIPTION,
  INTRO_TITLE: "Experience Life Reimagined at Dikalo",
  INTRO: "At Dikalo, we invite you to embark on a journey where sophistication intertwines seamlessly with cultural richness, transcending ordinary hospitality. From the moment you step into our world, you'll be embraced by a tapestry of elegance and authenticity, where every moment is crafted to celebrate life's simplest joys.",
  SPLITS: [
    {
      title: "Immersive Elegance, Authenticity Redefined",
      text: ["Immerse yourself in the vibrant pulse of our multicultural community, where connections flourish, experiences intertwine, and memories are woven into the fabric of time. With exclusive access to our boutique and investment opportunities, along with our digital third-space community, your exploration knows no bounds."],
      image: { src: "/images/about/celebration.webp", alt: "Guests in evening wear toasting with champagne", width: 1200, height: 801 },
    },
    {
      title: "Guided by Joie de Vivre en Afrique",
      text: ["Guided by the spirit of Joie de Vivre en Afrique, you'll discover a realm where culinary delights tantalize your taste buds, local cultures enchant your senses, and elegant accommodations provide sanctuary for the soul. Dikalo is more than just a destination—it's a celebration of life itself."],
      image: { src: "/images/about/toast.webp", alt: "A smiling guest raising a glass", width: 1200, height: 800 },
      isImageFirst: true,
    },
    {
      title: "Redefining Travel, Celebrating Life",
      text: ["We redefine travel by honouring the art of privacy, indulging in farm-to-table gastronomy, and offering unparalleled seclusion for those seeking respite from the world. Within our spaces, a vibrant third-space community thrives, fostering meaningful connections and marking joyous celebrations."],
      image: { src: "/images/about/garden-table.webp", alt: "A long dinner table set on the lawn, seen from above", width: 1600, height: 1066 },
    },
  ],
  PEACE_TITLE: "DISCOVER PEACE IN BRYANSTON",
  PEACE: [
    "Dikalo Boutique Hotel, your elegant oasis in Bryanston in Gauteng, close to Sandton and Fourways. Our meticulously designed rooms offer unparalleled comfort and tranquillity, perfect for travellers, sports teams, families, and friends.",
    "Conveniently located near top hospitals, prestigious schools, premier sports facilities, and major highways, our hotel ensures a seamless stay. Indulge in culinary delights and vibrant entertainment on your doorstep. Experience the luxury and convenience you’ve always dreamt of. Book your stay today and create lasting memories with us.",
  ],
  VALUES: [
    { title: "INTEGRITY, EMPATHY, AND CURIOSITY", text: "Our actions are guided by these values, ensuring genuine care and a welcoming atmosphere for all our guests." },
    { title: "SOPHISTICATION AND GRACE", text: "Connected and well-networked, we navigate every detail with confidence, ensuring your stay is seamlessly elegant." },
    { title: "TRUSTED LEADERSHIP AND GENUINE CONNECTIONS", text: "As trusted leaders, we prioritize authentic connections, ensuring you feel seen, heard, and truly valued throughout your stay." },
  ],
  TESTIMONIALS: [
    { quote: "I found this place to be a hidden treasure in the heart of the city, such a beautiful and tranquil atmosphere. The garden is breathtaking, I enjoyed the buffet thoroughly. Loved every aspect" },
    { quote: "The rooms are very clean, the atmosphere is welcoming and the staff is very good. The food is very nice and the place is conveniently located near shopping malls and the airport. The neighborhood is quiet and very safe." },
    { quote: "This hotel guesthouse is absolutely stunning. I've never seen such a clean. immaculate hotel in my life. And I travel around the world often. The staff goes above and beyond to make your stay flawless." },
    { quote: "I had the best time at Dikalo with my partner. We even forgot we were in the city. The service was superb, warm reception and friendly staff. Food was stunning. The pool is clean and the most wonderful garden." },
  ],
  CONVENIENCE_TITLE: "CONVENIENCE AND SERVICE ARE KEY",
  CONVENIENCE: [
    [
      "Exquisitely designed rooms and suites",
      "State-of-the-art hospitals ( Medfem Fertility Clinic)",
      "Dining and entertainment",
      "Schools and educational institutions",
      "Sports facilities",
      "Highway access from Bryanston and major routes to Sandton, Fourways and beyond",
    ],
    [
      "Sandton Financial District",
      "Bryanston Country Club",
      "Churches of all denominations",
      "Bryanston corporate offices",
      "Doctors, physios and various specialists",
    ],
  ],
};

/* ------------------------------ SERVICES ------------------------------ */

//Files are cached by browsers for a month, so a new version of a menu needs a new file name (not an overwrite)
export const MENU_LINKS = {
  MENU: "/files/dikalo-food-menu-2026-10.pdf",
  DRINKS: "/files/dikalo-drinks-list-2026-10.pdf",
};

export const MENUS = {
  TITLE: "Menu Options",
  DESCRIPTION: "Dikalo Highston's food menu and drinks list - breakfast, set menus and more at our restaurant in Bryanston.",
  BUTTONS: [
    { label: "Our Menu", href: MENU_LINKS.MENU },
    { label: "Drinks List", href: MENU_LINKS.DRINKS },
  ],
};

export const SERVICES = {
  TITLE: "Services and Facilities",
  FACILITIES: [
    ["ELEGANT GARDEN", "SWIMMING POOL", "EVENT VENUE"],
    ["CONCIERGE SERVICES", "CORPORATE MEETING", "AIRPORT TRANSFERS"],
  ],
  SPLITS: [
    {
      image: { src: "/images/services/solar-panels.webp", alt: "Solar panels", width: 1000, height: 667 },
      items: [
        { title: "Solar Back-Up Power", text: ["To lower our carbon footprint, we are becoming greener and efficient with our back-up solar energy system. You will forget loadshedding exists."] },
        { title: "Borehole Water Back-up", text: ["We are a water-wise establishment. Our water backup system will come in handy when you most need it."] },
        { title: "Airport Transfers", text: ["Our airport pickup and drop-off is available on request at a small cost for guest convenience."] },
        { title: "High-speed Internet Connection", text: ["We provide you with a high-speed connectivity for all your internet requirements. Online conferencing, meetings, watching your favorite shows, keeping in touch with friends and family etc."] },
      ],
    },
    {
      image: { src: "/images/services/conferencing.webp", alt: "Delegates reading a conference programme at Dikalo", width: 1200, height: 800 },
      isImageFirst: true,
      items: [
        { title: "Event Venue", text: ["At Dikalo Highston, our professional in-house event coordinator turns your ideas into unforgettable meetings and conferences at our boutique venue in Bryanston.We are the perfect venue in Bryanston for memorable corporate events and exclusive gatherings."] },
        {
          title: "Meeting and Business",
          text: [
            "Transform Your Conference into a Seamless Experience.",
            "When your event extends beyond a single day, integrated on-site accommodation elevates both convenience and impact. At Dikalo Highston, 12 well-appointed rooms to sleep your team allow delegates to transition effortlessly from conference sessions to refined dining and restful comfort all within a secure, private setting designed for focus, discretion, and ease.",
          ],
          listTitle: "Ideal for:",
          list: [
            "Multi-day conferences requiring continuity and flow",
            "Executive strategy sessions in a discreet, distraction-free environment",
            "International and out-of-town delegates seeking comfort and convenience",
            "Early-morning programmes where proximity enhances productivity",
            "Team-building retreats that benefit from shared space and extended engagement",
          ],
        },
      ],
    },
    {
      image: { src: "/images/services/canapes.webp", alt: "Canapés, meatballs and sushi platters", width: 1080, height: 1000 },
      items: [
        { title: "Mobile Bar", text: ["We have a mobile bar which provides style and convenience for our guests' needs. It is used as a décor feature at events."] },
        {
          title: "Restaurant",
          text: ["With an in-house chef, we offer a wide range of in-house gourmet dishes and African cuisines that would whet your appetite. Our chic and classy restaurant looks over the garden and swimming pool. We offer healthy options too.\nOrder from our menu options and enjoy the experience."],
          buttons: [
            { label: "Our Menu", href: MENU_LINKS.MENU },
            { label: "Drinks List", href: MENU_LINKS.DRINKS },
          ],
        },
        {
          title: "Spit Braai",
          text: ["In honour of our South African braai heritage and culture, we offer spit braai.\nFrom the spit-braai to your plate."],
          //Opened the drinks list PDF on Wix - now goes to the event enquiry form
          buttons: [{ label: "Book your event with us to enjoy our Spit-braai", path: `${ROUTES.EVENTS}#${ANCHORS.EVENT_FORM}` }],
        },
      ],
    },
    {
      image: { src: "/images/about/sandton-skyline.webp", alt: "The Sandton skyline at sunset", width: 2000, height: 1032 },
      isImageFirst: true,
      items: [
        { title: "Concierge Service", text: ["Our concierge services will facilitate transport,shuttles and tours on request.At Dikalo we understand the value of guided tours/ private tours for leisure travel and group travel where shared experiences enhance the journey and foster deeper connections.This is a chance for a seamless blend of adventure and relaxation, giving travelers the opportunity to explore South Africa"] },
        { title: "Security Guard House", text: ["We offer 24/7 security at the guard house as you commute in and out of our establishment."] },
        { title: "Electric Fencing and alarm", text: ["Dikalo is protected with and alarm system and electric fence for your security."] },
        { title: "Secure Parking", text: ["We offer 24/7 secure parking knowing that your car and belongings are safe as you relax."] },
      ],
    },
  ],
  OUTRO: "We understand that when you travel, you want to experience the comforts of home. That's why we pride ourselves on offering top-notch amenities to ensure your stay is nothing short of exceptional. Our services range from card facilities for seamless transactions to high-speed internet for staying connected, and even solar backup power and borehole water to ensure uninterrupted comfort.",
};

/* ------------------------------ ROOMS & SUITES ------------------------------ */

const roomPhotos = (slug, alts) => alts.map((alt, i) => ({ src: `/images/rooms/${slug}-${i + 1}.webp`, alt }));

export const ROOMS = {
  TITLE: "Rooms & Suites",
  DESCRIPTION: "Dikalo Highston offers a wide variety of room types, each furnished for comfort and luxury. We also offer additional amenities like Laundry services, Day tours, Turndowns and Flexible Check-in & Check-out times.",
  INTRO: "Dikalo Highston offers a wide variety of room types, each furnished for comfort and luxury. We also offer additional amenities like services & day tours.",
  //The counts strip under the intro. "slug" links to that room's section
  SUMMARY: [
    { name: "Standard Rooms", count: "2 ROOMS", slug: "standard-rooms" },
    { name: "Deluxe Rooms", count: "2 ROOMS", slug: "deluxe-rooms" },
    { name: "Standard Suites", count: "3 SUITES", slug: "standard-suites" },
    //Called "Honeymoon Suite" here on Wix but "Deluxe Suite" further down the page - kept as on Wix
    { name: "Honeymoon Suite", count: "1 SUITE", slug: "deluxe-suite" },
    { name: "Family Room", count: "2 APARTMENTS", slug: "family-room" },
  ],
  TYPES: [
    {
      slug: "deluxe-rooms",
      title: "DELUXE ROOMS",
      text: "Our Deluxe Rooms offer spacious comfort with the flexibility of a king bed or two twin beds on request, ideal for groups, and guests travelling together. Enjoy a stylish en-suite bathroom with double vanities, a bath, and walk-in rain shower.",
      amenities: ["Walk-in Raindance Shower", "Bathtub", "Hairdryer", "Complementary Wi-Fi", "Air-Conditioning", "HD TV – Smart TV box", "Coffee & Tea Station", "Mini Fridge", "Microwave", "In room safe", "Free bottle water"],
      size: "25 SQ M",
      bedding: "King Bed",
      capacity: "Up to 2 Adults",
      photos: roomPhotos("deluxe-room", ["Deluxe Room king bed", "Deluxe Room double vanity", "Deluxe Room bathroom with bath"]),
    },
    {
      slug: "standard-rooms",
      title: "STANDARD ROOMS",
      text: "Our Standard Rooms are painted with neutral tones to complement the palette of our Dikalo Highston surrounding. With comfortable king beds, dedicated work desk, en-suite bathroom with shower complete with amenities.",
      amenities: ["Shower", "Hairdryer", "Complementary Wi-Fi", "Air Conditioning", "HD TV – Smart TV box", "Coffee & Tea Station", "Mini Fridge", "Microwave", "In room safe", "Free bottle water"],
      size: "16 SQ M",
      bedding: "King Bed",
      capacity: "Up to 2 Adults",
      photos: roomPhotos("standard-room", ["Standard Room with mirror and armchair", "Wine at the bedside in a Standard Room", "Work desk in a Standard Room"]),
    },
    {
      slug: "standard-suites",
      title: "STANDARD SUITES",
      text: "Our Suites are spacious and capture the charm of Dikalo Highston will separate lounge area, a dedicated working desk as well as plush queen size beds offer a restful and comfortable experience. The suites are softly decorated to create touch with an en-suite bathroom.",
      amenities: ["Shower", "Hairdryer", "Complementary Wi-Fi", "Air-Conditioning", "HD TV – Smart TV box", "Coffee & Tea Station", "Mini Fridge", "Microwave", "In room safe", "Free bottle water"],
      size: "40 SQ M",
      bedding: "Queen Bed",
      capacity: "Up to 2 Adults",
      photos: roomPhotos("standard-suite", ["Standard Suite queen bed", "Standard Suite lounge area", "Standard Suite bed"]),
    },
    {
      slug: "deluxe-suite",
      title: "DELUXE SUITE",
      text: "Our gorgeous and inviting, Deluxe Suite offers upscale comfort and privacy, with a generous lounge area, kitchenette & small dining table. The suite has a king bed, en suite bathroom with Jacuzzi bath, double vanity, walk-in Raindance shower and private courtyard.",
      amenities: ["Walk-in Raindance Shower", "Jacuzzi Bathtub", "Hairdryer", "Complementary Wi-Fi", "Air-Conditioning", "HD TV – Smart TV box", "Kitchenette", "In room safe", "Free bottle water"],
      size: "45 SQ M",
      bedding: "Extra King Bed",
      capacity: "Up to 2 Adults",
      photos: roomPhotos("deluxe-suite", ["Deluxe Suite extra king bed", "Deluxe Suite Jacuzzi bath and shower", "Deluxe Suite daybed and wardrobe"]),
    },
    {
      slug: "family-room",
      title: "FAMILY ROOM",
      text: "Two separate queen size bedrooms both with en-suite bathrooms connected by a shared lounge, kitchenette and small dining area.",
      amenities: ["Walk-in Raindance Shower", "Complementary Wi-Fi", "Air-Conditioning", "HD TV – Smart TV box", "Kitchenette", "In room safe", "Free bottle water"],
      size: "70 SQ M",
      bedding: "Queen Bed",
      capacity: "Up to 4 Adults",
      photos: roomPhotos("family-room", ["Family Room bedroom", "Family Room lounge", "Family Room bedroom with window"]),
    },
  ],
  GROUPS_TITLE: "GROUP STAYS",
  GROUPS: ["Wedding Guests", "Sports Teams", "Church Groups", "Company Delegations", "Educational Groups"],
  GROUPS_BUTTON: "Request group rates",
};

/* ------------------------------ PRIVATE EVENTS ------------------------------ */

export const EVENTS = {
  TITLE: "Private Events",
  DESCRIPTION: "Dikalo Highston features a wide variety of event venues making it possible for us to host a board spectrum of events. Our mission is to provide excellent service and help our guests create unforgettable memories",
  WELCOME_TITLE: "WE WELCOME ALL EVENTS",
  WELCOME: "Brief our team to bring your event to life in a magical way.",
  //Each button opens the enquiry form with that event type chosen
  EVENT_TYPES: ["Birthdays", "Conference Venue", "Baby Showers", "Corporate Meetings", "Year End Functions", "Intimate Weddings", "Bridal Shower", "Kids Birthday Parties", "Team Building Events"],
  SPLITS: [
    {
      title: "PRIVATE CELEBRATIONS",
      text: ["Our attention to detail and full event service is designed to allow you to focus on hosting your guests while we ensure the details are taken care of. From AV, Sound and Lighting to stylish décor, the possibilities are endless."],
      image: { src: "/images/events/champagne.webp", alt: "A Dikalo Highston waiter pouring champagne", width: 1000, height: 1500 },
      isImageFirst: true,
    },
    {
      title: "COMPANY WORKSHOPS\n& \nTEAM BUILDING EVENTS",
      text: ["Bring your team to a quiet and private location where you can focus on achieving your strategic goals, while we ensure your event runs smoothly. From food and beverage to AV and presentation support, our service is beyond professional."],
      image: { src: "/images/about/flowers-table.webp", alt: "A table set with white flowers for a group lunch", width: 2000, height: 1334 },
    },
  ],
  SURROUNDINGS: "Bring your event to life in elegant, flexible surroundings that encourage you to unleash your creative flair. From our spacious banqueting rooms to our generous patio overlooking a beautiful garden, the possibilities are endless.",
  FEATURES: [
    { title: "Creating Lasting Memories", text: "Imagine a sunlit terrace adorned with flowers, where laughter fills the air and memories are made. This is where birthdays become cherished moments, surrounded by loved ones and warmth." },
    { title: "Private Events", text: "At Dikalo we offer a serene garden setting in Bryanston, the perfect backdrop for private celebrations, including exclusive kids’ birthday parties for the discerning parent. Celebrate life’s special moments with style and elegance at our venue in Bryanston." },
    { title: "Savor the Experience", text: "In a city as dynamic as Johannesburg, where options are abundant, Dikalo Highston offers something different: a sense of intention. Every meeting held here, every event hosted, and every guest accommodated becomes part of a larger story one where connection, comfort, and excellence intersect." },
    { title: "Creating Connections", text: "From corporate retreats to team-building events, Dikalo provides the perfect setting to forge strong bonds, surrounded by nature's beauty and luxury." },
  ],
  SERVICE_TITLE: "Insightful Service",
  SERVICE: "We understand the importance of every occasion, whether it's welcoming a new life or celebrating a union. Our dedicated team ensures that your baby showers and weddings are tailored to your style and vision, making them truly magical.",
  TESTIMONIALS_TITLE: "What our clients say about us",
  TESTIMONIALS: [
    { quote: "I hosted a 40th birthday for my husband this past Sunday. And to say it was amazing is an understatement! The staff at Dikalo Highston truly know what it means to create an experience. Everything Jessica and I spoke about was there. The spit braai was amazing! The men and women who helped were also on the ball. It felt magical. And honestly a group of people who were there to please. Can't recommend this place enough. it was special to host a private event here and we are still receiving rave reviews from our guests. Thank you Jessica. Mr. Oros. Noma. Thando. Dean and the rest of the team you guys were phenomenal! Will be back for another birthday celebration soon." },
    { quote: "Absolutely love the reception at Dikalo. The food is great and hospitality is very receptive and warm.", author: "Ginika E" },
    { quote: "Attended an intimate celebration there. Beautiful venue, intimate, peaceful, clean and great service. Lovely garden with pool. Food was alright and drinks options were good. Would visit again." },
    { quote: "Great food and atmosphere, lovely Sunday sundowners." },
    { quote: "Dikalo Highston has been key in successful launch events for our church events and it's just been a wonderful experience." },
  ],
  FORM_TITLE: "ENQUIRE",
  //The three drop-downs were empty on the Wix site (their options never loaded). These options are our best guess - confirm with the client
  CATERING_OPTIONS: ["A La Carte", "Buffet Menu", "Spit Braai", "Platter"],
  CONFERENCING_OPTIONS: ["Yes", "No"],
  VIEWINGS: "Venue viewings are required for all event bookings. We have viewings on Tuesday, Wednesday and Friday between 10:00 - 14:00. Viewings are by appointment only.",
  PROMISE_TITLE: "Our Promise of Excellence",
  PROMISE: "Our commitment runs deeper than hosting successful events – it is a commitment to the entire experience we offer. Our dedication to excellence runs through every aspect of your time with us, ensuring that your experience is nothing short of exceptional.",
};

/* ------------------------------ GALLERY ------------------------------ */

const GALLERY_ALTS = [
  "Pink lounge set-up for a kids' party",
  "Themed first-birthday party décor with balloons",
  "Bubble house, balloons and picnic set-up on the lawn",
  "The swimming pool and garden",
  "A bedroom being prepared by housekeeping",
  "A bedroom with a buttoned headboard",
  "The indoor conference and banqueting venue",
  "Breakfast served in the garden beside the pool",
  "Outdoor tables beside the pool",
  "Tea set out on the pool terrace",
  "An en-suite bathroom with bath",
  "A suite lounge with kitchenette",
  "A king bed against a brick feature wall",
  "View of the garden and pool from a room window",
  "A dressing table with mirror",
  "A work desk in a bedroom",
  "A sitting area with armchairs",
  "A bathroom with basin and bath",
  "A wardrobe with bathrobes",
  "A garden table set for an event",
  "The covered patio",
  "An event table set with flowers beside the pool",
  "A banquet table with autumn flowers",
  "White roses and candles on an event table",
  "Baby shower décor with white and gold balloons",
  "A black and silver event table setting",
];

export const GALLERY = {
  TITLE: "Gallery",
  DESCRIPTION: "Photos of Dikalo Highston in Bryanston - our rooms and suites, garden and pool, conference venue and private events.",
  PHOTOS: GALLERY_ALTS.map((alt, i) => ({ src: `/images/gallery/gallery-${String(i + 1).padStart(2, "0")}.webp`, alt })),
};

/* ------------------------------ CONTACT ------------------------------ */

export const CONTACT = {
  TITLE: "Contact Us",
  DESCRIPTION: "Contact Dikalo Highston, 9 Highland Avenue, Bryanston - WhatsApp +27 83 656 1137 for accommodation or call +27 71 869 2674 for events.",
  INTRO: "Dikalo Highston is conveniently located in Bryanston, Johannesburg, near Sandton and the Winnie Mandela Precinct. Our boutique accommodation is within easy reach of leading business hubs including The Campus Business Park, Knights Office Park, Turnberry Office Park and key Bryanston corporate offices, as well as nearby schools and New Life Church. This makes Dikalo Highston an ideal choice for corporate travellers, MICE delegates, school groups, sports teams, church groups and guests attending meetings, conferences and events at our venue.",
  GROUP_TITLE: "Group Booking Enquiry",
  FAQ_TITLE: "FAQ",
  FAQ: [
    {
      tab: "Events",
      items: [
        { q: "How do you manage event access?", a: ["A full invitee list required three days before event for security access. No one will be allowed access if not on list."] },
        { q: "Can balance be paid on the day of the event?", a: ["By agreement the service will not be provided unless full amount is paid."] },
        { q: "What happens to my deposit if I cancel two weeks before the event?", a: ["You’ll loss your deposit if event is cancelled two weeks before the event."] },
        { q: "What document is required to secure booking of venue?", a: ["A copy of customer ID document is required to secure venue booking."] },
        { q: "Do you provide cooking facilities for events in the venue?", a: ["No cooking allowed on site. Only food setup and warming facility available."] },
        { q: "What time should guest leave venue?", a: ["All invitees to leave venue at 10pm as agreed."] },
        { q: "How much do you charge from Midnight?", a: ["No event shall continue after midnight. No amount of money will be accepted. This is non-negotiable."] },
        { q: "What happens if guest are unruly during an event?", a: ["Dikalo Highston reserves the right to stop the event if client is not adhering to agreed terms and conditions."] },
      ],
    },
    {
      tab: "General Information",
      items: [
        { q: "What happens if a client stains your belongings?", a: ["Dry cleaning fee will be charged for any stains on our belongings."] },
        { q: "What are the check-in and check-out times at Dikalo Highston?", a: ["Check-in at Dikalo Highston is from 1:30 PM and check-out is until 10:00 AM"] },
        { q: "Are guests allowed to take anything out of the premises?", a: ["Under no circumstances shall property belonging to Dikalo Highston (e.g crockery, cutlery, linen furniture etc) leave our premises"] },
        { q: "What happens if a client damages anything in Dikalo Highston?", a: ["A replacement amount will be charged to the value of the damaged or broken item."] },
        { q: "Are invitees allowed everywhere within the property?", a: ["All invitees must operate only within agreed designated area."] },
        { q: "What is the capacity of your parking?", a: ["Our Parking can only contain - 70 cars inside & 5 cars outside"] },
        { q: "Are guests allowed to play music outside in the garden?", a: ["No Loud music is allowed in the garden area."] },
        { q: "Are guest allowed to go over agreed cut-off time?", a: ["Strict adherence to cut off times. Music must stop 15mins to agreed cut-off time."] },
      ],
    },
    {
      tab: "Accommodation",
      items: [
        { q: "What is your breakfast time?", a: ["Breakfast is from 7 – 10am."] },
        { q: "How many guests can sleep in a room?", a: ["Maximum of 2 people are allowed to sleep in a room."] },
        {
          q: "What type of accommodation can I book at Dikalo Highston?",
          a: ["Dikalo Highston offers the following accommodation options:"],
          list: ["Standard Room", "Deluxe Room", "Standard Suite", "Deluxe Suite", "Family Room"],
        },
        {
          q: "What type of breakfast does Dikalo Highston serve?",
          a: ["Guests who have stayed at Dikalo Highston rated its breakfast very highly: The property serves the following types of breakfast:"],
          list: ["Full English breakfast with side of seasonal fruit", "Vegan", "Vegeterian"],
        },
      ],
    },
  ],
};
